import { memo, } from "react";
import { useModeratorStore, } from "../../../../../store/moderatorStore.ts";
import { UpcomingPaymentBlockDefault, } from "./UpcomingPaymentBlockDefault.tsx";
import { UpcomingPaymentBlockModerator, } from "./UpcomingPaymentBlockModerator.tsx";

/**
 * Block encapsulating future payments view logic.
 */
function UpcomingPaymentBlockComponent() {
  const isModerator = useModeratorStore(state => state.isModerator,);

  return (
    <>
      {isModerator ? <UpcomingPaymentBlockModerator /> : <UpcomingPaymentBlockDefault />}
    </>
  );
}

export const UpcomingPaymentBlock = memo(UpcomingPaymentBlockComponent,);
